import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import { installNumberPaste } from './utils/numberPaste.js';
import { installDialogs } from './utils/dialogs.js';

installNumberPaste();
installDialogs();

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
